/* eslint-disable import/no-unresolved */
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
    useLazyQuery, useMutation, useQuery, useReactiveVar,
} from '@apollo/client';

import { CREATE_FFIEC031_USER_COMMENT, DELETE_FFIEC031_USER_COMMENT, UPDATE_FFIEC031_USER_COMMENT } from 'Apollo/Mutations/Rules/FFIEC031';
import { GET_USER_INFO } from 'Apollo/Queries';
import { GET_COMMENTS_FOR_FFIEC031 } from 'Apollo/Queries/Rules/FFIEC031Results';
import { tenantIdVar } from 'Apollo/config';
import FFIEC031Comment from '../components/FFIEC031Comment';

const FFIEC031Comments = ({ refetch }) => {
    const location = useLocation();
    const [batchId, setBatchId] = useState(location.state.batchId);
    const [ruleId, setRuleId] = useState(location.state.ruleId);
    const [ffiec031Comment, setFfiec031Comment] = useState('');
    const [ffiec031Show, setFfiec031Show] = useState(false);
    const [ffiec031Target, setFfiec031Target] = useState(null);
    const [ffiec031Edit, setFfiec031Edit] = useState(false);
    const [ffiec031SelectedComment, setFfiec031SelectedComment] = useState('');
    const [ffiec031SelectedCommentID, setFfiec031SelectedCommentID] = useState('');
    const [ffiec031SelectedIndex, setFfiec031SelectedIndex] = useState(null);
    const tenantId = useReactiveVar(tenantIdVar);

    /* Apollo query to fetch user information  */
    const getFFIEC031User = useQuery(GET_USER_INFO);

    /* Apollo lazy query to fetch all the comments  */
    const [getComments, { loading, data: { getUserCommentsForFFIEC031 = {} } = {} }] = useLazyQuery(GET_COMMENTS_FOR_FFIEC031, {
        variables: {
            input: {
                batchId: parseInt(batchId, 10),
                ruleId: parseInt(ruleId, 10),
                tenantId: parseInt(tenantId, 10),
            },
        },
        fetchPolicy: 'no-cache',
    });

    /* Apollo mutation to add new comment  */
    const [addResultComment, { loading: commentLoading }] = useMutation(CREATE_FFIEC031_USER_COMMENT, {
        variables: {
            input: {
                batchId: parseInt(batchId, 10),
                ruleId: parseInt(ruleId, 10),
                tenantId: parseInt(tenantId, 10),
                commentText: ffiec031Comment,
            },
        },
    });

    /* Apollo mutation to delete a comment  */
    const [deleteComment] = useMutation(DELETE_FFIEC031_USER_COMMENT);

    /* Apollo mutation to update comment  */
    const [updateComment] = useMutation(UPDATE_FFIEC031_USER_COMMENT);

    /* Comment option handler */
    const handleFFIEC031Click = (index, text, commentId, event) => {
        setFfiec031Show(!ffiec031Show);
        setFfiec031SelectedIndex(index);
        setFfiec031SelectedComment(text);
        setFfiec031SelectedCommentID(commentId);
        setFfiec031Target(event.target);
    };

    /* Calls  addResultComment(), getComments() and refetch that failed tests result */
    const addFFIEC031Comment = async () => {
        await addResultComment();
        getComments();
        refetch();
        setFfiec031Comment('');
    };

    /* Toggled edit value */
    const onFFIEC031EditClick = () => {
        setFfiec031Edit(!ffiec031Edit);
    };

    /* Cancal button handler */
    const onFFIEC031CancelClick = () => {
        setFfiec031Edit(!ffiec031Edit);
        setFfiec031SelectedIndex(null);
        setFfiec031SelectedComment('');
        setFfiec031Show(!ffiec031Show);
    };

    /* Calls updateComment and refetch the failed tests resut */
    const onFFIEC031ClickSave = async () => {
        await updateComment({
            variables: {
                input: {
                    commentText: ffiec031SelectedComment,
                    commentId: ffiec031SelectedCommentID,
                    tenantId: parseInt(tenantId, 10),
                    batchId,
                    ruleId,
                },
            },
        });
        getComments();
        setFfiec031Edit(!ffiec031Edit);
        setFfiec031SelectedIndex(null);
        setFfiec031SelectedComment('');
        setFfiec031Show(!ffiec031Show);
        refetch();
    };

    /* Calls deleteComment and refetch the failed tests resut */
    const onFFIEC031ClickDelete = async () => {
        await deleteComment({
            variables: {
                input: {
                    commentId: ffiec031SelectedCommentID,
                    tenantId: parseInt(tenantId, 10),
                    batchId,
                    ruleId,
                },
            },
        });
        getComments();
        setFfiec031SelectedIndex(null);
        setFfiec031SelectedComment('');
        setFfiec031Show(!ffiec031Show);
        refetch();
    };

    /* Side effect to fetch comments initially */
    useEffect(() => {
        getComments();
    }, []);

    /* Side effect when location state updates */
    useEffect(() => {
        setBatchId(location.state.batchId);
        setRuleId(location.state.ruleId);
    }, [location]);

    return (
        <FFIEC031Comment
            getFFIEC031User={getFFIEC031User}
            ffiec031Comment={ffiec031Comment}
            setFFIEC031Comment={setFfiec031Comment}
            commentLoading={commentLoading}
            addFFIEC031Comment={addFFIEC031Comment}
            loading={loading}
            getUserCommentsForFFIEC031={getUserCommentsForFFIEC031}
            handleFFIEC031Click={handleFFIEC031Click}
            onFFIEC031EditClick={onFFIEC031EditClick}
            onFFIEC031ClickDelete={onFFIEC031ClickDelete}
            onFFIEC031CancelClick={onFFIEC031CancelClick}
            onFFIEC031ClickSave={onFFIEC031ClickSave}
            ffiec031Show={ffiec031Show}
            ffiec031Target={ffiec031Target}
            ffiec031Edit={ffiec031Edit}
            ffiec031SelectedComment={ffiec031SelectedComment}
            ffiec031SelectedCommentID={ffiec031SelectedCommentID}
            setFFIEC031SelectedComment={setFfiec031SelectedComment}
            ffiec031SelectedIndex={ffiec031SelectedIndex}
        />
    );
};

export default FFIEC031Comments;
